import { useQuery } from '@apollo/client/react';
import type { AgentDevice } from '@staff-app/shared-types';
import { STAFF_AGENT_DEVICES } from '@staff-app/graphql-client';

interface AgentDevicesResult {
  staffAgentDevices: AgentDevice[];
}

/**
 * useAgentDevices — the logged-in staff user's personal device watchlist.
 * Server reads the caller from the auth context, so no args are needed.
 */
export function useAgentDevices() {
  const { data, loading, error, refetch } = useQuery<AgentDevicesResult>(STAFF_AGENT_DEVICES, {
    fetchPolicy: 'cache-and-network',
    // 'all' keeps partial data alongside field errors. Without it (default
    // 'none'), a single bad device doc — e.g. one with a null non-nullable
    // field — discards the ENTIRE response and blanks the whole list. As a
    // cross-tenant viewer we degrade gracefully: show every device we can.
    errorPolicy: 'all',
  });

  return {
    devices: data?.staffAgentDevices ?? [],
    loading,
    error,
    refetch,
  };
}
